export class MessageThreadInfo {
    public messageThreadType?: string;
    public members?: number[];
    public internshipSchedule?: number;
    public school?: number;
    public company?: number;

    constructor(model: Partial<MessageThreadInfo> = {}) {
        Object.assign(this, model);
    }
}

export type PMessageThreadInfo = Partial<MessageThreadInfo>;
